import { useState, useEffect, useCallback } from "react";

const LS_KEY = "be_theme";

function getAutoTheme() {
  // Auto: 6h-18h = light, else dark
  const hour = new Date().getHours();
  return hour >= 6 && hour < 18 ? "light" : "dark";
}

function getResolvedTheme(mode) {
  if (mode === "auto") return getAutoTheme();
  return mode;
}

export function useTheme() {
  const [mode, setMode] = useState(() => {
    try { return localStorage.getItem(LS_KEY) || "dark"; } catch { return "dark"; }
  });

  const resolved = getResolvedTheme(mode);

  // Apply data-theme attribute
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
  }, [resolved]);

  // Auto mode: re-check every minute
  useEffect(() => {
    if (mode !== "auto") return;
    const interval = setInterval(() => {
      document.documentElement.setAttribute("data-theme", getAutoTheme());
    }, 60000);
    return () => clearInterval(interval);
  }, [mode]);

  const setTheme = useCallback((newMode) => {
    setMode(newMode);
    try { localStorage.setItem(LS_KEY, newMode); } catch {}
  }, []);

  const cycleTheme = useCallback(() => {
    const next = mode === "dark" ? "light" : mode === "light" ? "auto" : "dark";
    setTheme(next);
  }, [mode, setTheme]);

  return { mode, resolved, setTheme, cycleTheme };
}
